<template>
  <div class="card">
    <v-form>
      <div
        class="py-6 d-flex flex-column justify-space-between"
        style="height: 400px"
      >
        <div>
          <div class="img-wrapper">
            <img
              :src="require('@/assets/Success.gif')"
              style="width: 200; height: 200px"
              alt="Check Email"
              class="ml-2"
            />
          </div>
          <div
            class="text-center"
            style="font-size: 30px; font-weight: 500; font-family: Montserrat"
          >
            Successful
          </div>
        </div>

        <div class="mb-5">
          <v-btn
            block
            color="#1b1a47"
            class="text-white pro-login"
            size="large"
            @click="goToApplication()"
            >Proceed to Login
            <v-icon class="ml-1" size="22"
              >mdi mdi-logout-variant</v-icon
            ></v-btn
          >
        </div>
      </div>
    </v-form>
  </div>
</template>

<script>
export default {
  components: {},
  methods: {
    goToApplication() {
      let url = localStorage.getItem("REDIRECT_URL");
      window.location = url;
    },
  },
};
</script>

<style scoped>
.img-wrapper {
  display: flex;
  justify-content: center;
}
.pro-login {
  font-size: 16px;
  font-weight: 700;
  border-radius: 4px;
}
.card {
  width: 320px;
  background-color: #fff;
  border-radius: 12px !important;
  padding: 16px !important;
  border: none;
  box-shadow: none;
  height: 400px; 
}

</style>
